











import { Vue, Component, Prop } from 'vue-property-decorator';

export type Direction = 'right'  | 'bottom' | 'left' | 'top' ;

@Component({})
export default class IconArrow extends Vue {
    @Prop({ default: 'right' }) direction!: Direction;
}
